<template>
  <div :class="['video_pop', theme]">
    <div :class="['video_pop_box', animationName]">
      <div class="video_pop_left">
        <p class="product_info_name">
          <span>{{ productInfo.name }} {{ productInfo.age }}岁</span>
        </p>
        <p class="product_info_baof">
          交多少：{{ productInfo.baofDesc }}
        </p>
        <p class="product_info_period">
          交多久：{{ productInfo.periodDesc }}
        </p>
        <p class="product_info_period">
          保多久：{{ productInfo.durationDesc }}
        </p>
        <p class="product_info_baoe">
          保&nbsp;&nbsp;&nbsp;&nbsp;额：{{ productInfo.baoeDesc }}
        </p>
        <p class="video_pop_tips">
          <span>(注：具体责任以保险条款为准)</span>
        </p>
      </div>
      <div v-if="productInfo.liabilities" class="video_pop_right">
        <p v-for="lia in productInfo.liabilities" :key="lia" v-html="lia" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoPop',
  components: {
  },
  filters: {},
  mixins: [],
  props: {
    theme: String,
    productInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      animationName: ''
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.animationName = 'zoomIn'
  },
  destroyed () {
    this.animationName = ''
  },
  methods: {},
};
</script>

<style>
.video_pop {
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 101%;
  background: rgba(0,0,0,0.5);
  z-index: 20;
  color: #6460ff;
  text-align: left;
  pointer-events: none;
  text-align: center;
  & .video_pop_box {
    display: inline-block;
    width: 94%;
    height: 120px;
    line-height: 1.2;
    margin: 0 auto 10px;
    background: #fff;
    border-radius: 8px;
    border: 2px solid rgba(100, 96, 255, 0.5);
    box-sizing: border-box;
    font-size: 0;
    overflow: hidden;
    vertical-align: bottom;
    & .video_pop_left {
      display: inline-block;
      width: 45%;
      max-height: 100%;
      padding: 12px 12px;
      font-size: 12px;
      vertical-align: middle;
      box-sizing: border-box;
      text-align: left;
      > p {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      & .product_info_name {
        margin-bottom: 4px;
        > span {
          display: inline-block;
          padding: 4px 8px;
          background: #6460ff;
          color: #fff;
          border-radius: 50px;
          box-sizing: border-box;
        }
      }
      & .video_pop_tips {
        color: #ff5949;
        text-overflow: initial;
        span {
          display: inline-block;
          transform: scale(0.65);
          transform-origin: left;
        }
      }
    }
    & .video_pop_right {
      display: inline-block;
      width: 55%;
      max-height: 100%;
      line-height: 1.35;
      padding: 12px 12px 12px 0;
      color: #333;
      font-size: 12px;
      vertical-align: middle;
      box-sizing: border-box;
      text-align: left;
      > p {
        position: relative;
        padding-left: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:before,
        &::before {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background: #6460ff;
          content: ' ';
        }
        span {
          color: #6460ff;
        }
      }
    }
  }
  &:after,
  &::after {
    display: inline-block;
    width: 1px;
    height: 100%;
    content: ' ';
    visibility: hidden;
    vertical-align: bottom;
  }
  &.diff {
    color: #d94926;
    & .video_pop_box {
      border: 2px solid #d94926;
      & .video_pop_left {
        & .product_info_name {
          > span {
            background: #d94926;
          }
        }
        & .video_pop_tips {
          color: #d94926;
        }
      }
      & .video_pop_right {
        > p {
          &:before,
          &::before {
            background: #d94926;
          }
          span {
            color: #d94926;
          }
        }
      }
    }
  }  
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.zoomIn {
  animation: zoomIn 2s;
  transform-origin: center;
}
</style>
